const urlParamsMapper = (url, params) => {
  const urlParts = url.split('/');
  const lastPartIndex = urlParts.length - 1;
  let urlWithParams = '';

  urlParts.forEach((part, index) => {
    if (part.charAt(0) === ':') {
      urlWithParams += encodeURIComponent(params[part.substr(1)]);
    } else {
      urlWithParams += part;
    }
    if (index < lastPartIndex) {
      urlWithParams += '/';
    }
  });

  return urlWithParams;
};

export default urlParamsMapper;
